import { createAsyncThunk } from "@reduxjs/toolkit";
import { ErrorApi } from "@core/modeles/model.ts";
import { InterimAgentPostDTO } from "@modules/setting/userManagement/interimAgent/interimAgent.model.ts";
import { interimAgentService } from "@modules/setting/userManagement/interimAgent/interimAgent.service.ts";

export const createInterimAgent = createAsyncThunk(
  "interimAgent/create",
  async ({
    filter,
    onSuccess,
    onError,
  }: {
    filter: InterimAgentPostDTO;
    onSuccess: () => void;
    onError: (error: ErrorApi) => void;
  }) => {
    try {
      const result = await interimAgentService.createInterimAgent(filter);
      if (onSuccess) onSuccess();
      return result;
    } catch (error) {
      onError(error as ErrorApi);
    }
  }
);

export const getAllInterimAgents = createAsyncThunk(
  "interimAgent/list",
  async (filter: {
    page: number;
    size: number;
    sortBy?: string;
    sortDir?: string;
    search?: string;
    active?: string;
  }) => {
    return await interimAgentService.getAllInterimAgents(
      filter.page,
      filter.size,
      filter.sortBy,
      filter.sortDir,
      filter.search,
      filter.active
    );
  }
);

export const returnInterimAgent = createAsyncThunk(
  "interimAgent/return",
  async ({
    id,
    onSuccess,
    onError,
  }: {
    id: number;
    onSuccess: () => void;
    onError: (error: ErrorApi) => void;
  }) => {
    try {
      const result = await interimAgentService.returnInterimAgent(id);
      if (onSuccess) onSuccess();
      return result;
    } catch (error) {
      onError(error as ErrorApi);
    }
  }
);
